/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import config from '../../../config';
import { useThemeBrand } from '@features/theme/context/ThemeContext';
import { useAppSelector } from '@reducers/index';
import { isStaff } from '@selectors/user';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { Toggle } from '@g17eco/molecules/toggle';
import './styles.scss';

export const BrandToggle = () => {
  const isUserStaff = useAppSelector(isStaff);
  const { theme, setTheme } = useThemeBrand();

  if (!config.features.darkMode || !isUserStaff) {
    return null;
  }

  const isCompany = theme === 'company';
  const tooltipText = isCompany ? 'Switch to Materiality Tracker branding' : 'Switch to Company Tracker branding';

  const toggleTheme = () => {
    setTheme(isCompany ? 'materiality' : 'company');
  };

  return (
    <SimpleTooltip text={tooltipText}>
      <div className='d-flex align-items-center'>
        <Toggle
          checked={!isCompany}
          onChange={toggleTheme}
          label={!isCompany ? 'Materiality Tracker' : 'Company Tracker'}
        />
      </div>
    </SimpleTooltip>
  );
};
